import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import get from 'lodash/get';
import { Echo } from '@storable/echo';
import WebsiteApp from '../../../src/web/containers/App';
import getLocale from './getLocale';

const { NODE_ENV } = process.env;
const isDevelopment = NODE_ENV === 'development';

const propTypes = {
  children: PropTypes.node,
  fullStoryEnabled: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    companyId: PropTypes.string.isRequired,
  }).isRequired,
  softwareProviders: PropTypes.arrayOf(
    PropTypes.string,
  ).isRequired,
  fonts: PropTypes.shape({
    primary: PropTypes.shape({
      href: PropTypes.string.isRequired,
    }),
    secondary: PropTypes.shape({
      href: PropTypes.string.isRequired,
    }),
  }),
  themeClasses: PropTypes.string,
};

const defaultProps = {
  children: undefined,
  fonts: undefined,
  themeClasses: undefined,
};

const App = ({
  children,
  fullStoryEnabled,
  user,
  softwareProviders,
  fonts,
  themeClasses,
  ...rest
}) => {
  const primaryFontHref = get(fonts, 'primary.href');
  const secondaryFontHref = get(fonts, 'secondary.href');

  const echoSoftwareProviderFilter = softwareProviders.length === 1
    ? softwareProviders[0]
    : null;

  return (
    <Echo userId={user.id} softwareProvider={echoSoftwareProviderFilter}>
      <WebsiteApp
        {...rest}
        getLocale={getLocale}
      >
        <Helmet>
          {themeClasses && (
            <style type="text/css">
              {themeClasses}
            </style>
          )}
          {primaryFontHref && (
          <link href={primaryFontHref} rel="stylesheet" />
          )}
          {secondaryFontHref && (
          <link href={secondaryFontHref} rel="stylesheet" />
          )}
          {!isDevelopment && fullStoryEnabled && (
            <script type="application/javascript">{`
              window['_fs_debug'] = false;
              window['_fs_host'] = 'fullstory.com';
              window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
              window['_fs_org'] = '4H58C';
              window['_fs_namespace'] = 'FS';
              (function(m,n,e,t,l,o,g,y){
                if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
                g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];
                o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;
                y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
                g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
                g.anonymize=function(){g.identify(!!0)};
                g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
                g.log = function(a,b){g("log",[a,b])};
                g.consent=function(a){g("consent",!arguments.length||a)};
                g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
                g.clearUserCookie=function(){};
                g.setVars=function(n, p){g('setVars',[n,p]);};
                g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];
                if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};
                g._v="1.3.0";
              })(window,document,window['_fs_namespace'],'script','user');
          `}</script>
          )}
        </Helmet>
        {children}
      </WebsiteApp>
    </Echo>
  );
};

App.propTypes = propTypes;
App.defaultProps = defaultProps;

export default App;
